<template>
  <div class="page">
    <div v-if="isEdit">
      <div class="row justify-content-end">
        <div class="col col-auto">
          <b-button @click="onFormSettingCancel">
            {{ $t('キャンセル') }}
          </b-button>
        </div>
        <div class="col col-auto">
          <b-button @click="onFormSettingComplete">
            {{ $t('設定完了') }}
          </b-button>
        </div>
      </div>
      <iframe
        :id="`method-drow-elem-${index}`"
        :src="methodDrowPath"
        width="100%"
        height="700"
        frameborder="0"
      ></iframe>
    </div>
    <div v-show="!isEdit">
      <div class="row justify-content-between d-print-none">
        <div class="col col-auto">
          <b-button @click="onFormSettingStart">{{ $t('帳票設定') }}</b-button>
        </div>
        <div class="col col-auto">
          <b-button @click="onPrint">{{ $t('印刷') }}</b-button>
        </div>
      </div>

      <div :id="`page-${index}`"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { SVG } from '@svgdotjs/svg.js'

const PageTypeSingle = 'type1'
const PageTypeMultiple = 'type2'


export default {
  props: {
    index: {
      type: Number,
      require: true,
    },
    type: {
      type: String,
      default: '',
    },
    maxRow: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      svg: null,
      svgString: '',
      isEdit: false,
      revokeUrls: [], // 削除するURLのリスト
    }
  },
  mounted() {
    this.$emit('loaded', this.index)
  },
  destroyed() {
    this.revokeUrls.forEach(url => URL.revokeObjectURL(url))
  },
  methods: {
    getTime() {
      const date = new Date()
      return date.getTime()
    },
    showSvgData(svg, values, rows, images) {
      this.svgString = svg
      this.svg = this.convertSvgData(this.svgString)
      this.deleteTspan(this.svg)
      this.svg.node.innerHTML = this.replaceValues(this.svg.node.innerHTML, values)
      const tmpPageIds = this.svgString.match(/id="([^"]*)-(type[0-9]+)-([0-9]+)"/g)
      const pages = []
      for (const tmpPageId of tmpPageIds) {
        const items = tmpPageId.match(/([^"]*)-(type[0-9]+)-([0-9]+)/)
        pages.push({
          id: items[0],
          type: items[2],
        })
      }
      // type1（シングルページ）かどうかを検査
      let hasMultiPage = false
      let pageType = PageTypeSingle
      for (const page of pages) {
        const pageNode = this.svg.findOne(`#${page.id}`)
        const detailBodies = pageNode.node.innerHTML.match(/detail-body-[0-9]*/g)
        if (!detailBodies || detailBodies.length === 0) continue
        if (page.type === PageTypeSingle) {
          if (rows.length > detailBodies.length) {
            pageType = PageTypeMultiple
          }
        } else {
          hasMultiPage = true
        }
      }
      pageType = hasMultiPage ? pageType : PageTypeSingle
      let y = 0
      let height = 0
      const newPages = []
      for (const page of pages) {
        const pageNode = this.svg.findOne(`#${page.id}`)
        if (page.type !== pageType) {
          y += pageNode.height()
          pageNode.remove()
          continue
        }
        pageNode.transform({
          translateX: pageNode.transform().translateX,
          translateY: pageNode.transform().translateY - y,
        })
        height += pageNode.height()
        newPages.push(page)
      }

      const box = {
        x: 0,
        y: 0,
        width: this.svg.node.viewBox.baseVal.width,
        height: height,
      }
      this.svg.node.setAttribute('viewBox', `${box.x} ${box.y} ${box.width} ${box.height}`)
      if (pageType === PageTypeSingle) {
        this.setSinglePageDetailBody(rows, this.svg, newPages)
      } else {
        this.setMultiPageDetailBody(rows, this.svg)
      }
      this.setImages(this.svg, images)
      this.rightJustify(this.svg)
    },
    setSinglePageDetailBody(rows, svg, pages) {
      for (const page of pages) {
        const pageNode = svg.findOne(`#${page.id}`)
        for (let k in this.$appConfig.BusinessFormDetailKeys) {
          const key = this.$appConfig.BusinessFormDetailKeys[k]

          const targets = pageNode.node.innerHTML.match(new RegExp(`id="${key}[-]*[0-9]*"`, 'g'))
          if (!targets || !Array.isArray(targets)) continue
          for (let [index, target] of targets.entries()) {
            const tmp = target.match(new RegExp(`${key}[-]*[0-9]*`))
            const data = svg.findOne(`#${tmp[0]}`)
            if (index < rows.length) {
              data.text(rows[index][key])
              if (
                key === this.$appConfig.BusinessFormDetailKeys.Quantity ||
                key === this.$appConfig.BusinessFormDetailKeys.UnitPrice ||
                key === this.$appConfig.BusinessFormDetailKeys.Price
              ) {
                data.node.setAttribute('text-anchor', 'end')
              }
            } else {
              data.text('')
            }
          }
        }
      }
      return svg

    },
    setMultiPageDetailBody(rows, svg) {
      for (let k in this.$appConfig.BusinessFormDetailKeys) {
        const key = this.$appConfig.BusinessFormDetailKeys[k]

        const targets = svg.node.innerHTML.match(new RegExp(`id="${key}[-]*[0-9]*"`, 'g'))
        if (!targets || !Array.isArray(targets)) continue
        for (let [index, target] of targets.entries()) {
          const tmp = target.match(new RegExp(`${key}[-]*[0-9]*`))
          const data = svg.findOne(`#${tmp[0]}`)
          if (index < rows.length) {
            data.text(rows[index][key])
            if (
              key === this.$appConfig.BusinessFormDetailKeys.Quantity ||
              key === this.$appConfig.BusinessFormDetailKeys.UnitPrice ||
              key === this.$appConfig.BusinessFormDetailKeys.Price
            ) {
              data.node.setAttribute('text-anchor', 'end')
            }
          } else {
            data.text('')
          }
        }
      }
      return svg
    },
    convertSvgData(svg) {
      const page = document.getElementById(`page-${this.index}`)
      // namespace重複エラー対策
      const replacedSvg = svg.replace(
        'xmlns:svgjs="http://svgjs.dev/svgjs"',
        '',
      )
      page.innerHTML = replacedSvg
      const domSvg = page.querySelector('svg')
      domSvg.setAttribute('id', this.svgId)
      return SVG(domSvg).size('100%', '100%')
    },
    onFormSettingStart() {
      const svgText = this.svg.node.outerHTML
      localStorage.setItem('md-canvasContent', svgText)
      this.isEdit = true
    },
    onFormSettingCancel() {
      this.isEdit = false
    },
    onFormSettingComplete() {
      const methodDrowElem = document.getElementById(
        `method-drow-elem-${this.index}`,
      )
      const methodDrowDocument = methodDrowElem.contentWindow.document
      const svg = methodDrowDocument.getElementById('svgcontent')

      this.isEdit = false
      this.setSvgData(svg.outerHTML)
    },
    onPrint() {
      window.print()
    },
    replaceValue(svg, id, value) {
      return svg.replace(new RegExp(`{{${id}}}`, 'g'), value || '')
    },
    replaceValues(svg, elements) {
      elements.forEach(e => svg = this.replaceValue(svg, e.id, e.value))
      return svg
    },
    rightJustify(svg) {
      const templateIds = ['TotalPricePage', 'TaxPage', 'SubtotalPage', 'TotalPrice']
      for (const templateId of templateIds) {
        const tempIds = svg.node.innerHTML.match(new RegExp(`id="${templateId}[-]*[0-9]*"`))
        if (!Array.isArray(tempIds)) continue
        for (const tempId of tempIds) {
          const id = tempId.match(new RegExp(`${templateId}[-]*[0-9]*`))
          const element = svg.findOne(`#${id}`)
          element.node.setAttribute('text-anchor', 'end')
        }
      }
      return svg
    },
    async getImageValue(url) {
      if (url) {
        // s3一時リンクなので、iframe内で期限切れにならないように対策
        const { data } = await axios.get(url, { responseType: 'blob' })
        const newUrl = URL.createObjectURL(data)
        this.revokeUrls.push(newUrl)
        const image = SVG().image(newUrl)
        return image
      }
      return ''
    },
    setImages(svg, images) {
      images.forEach(image => {
        if (image.value) {
          this.setImage(svg, image)
        }
      })
    },
    setImage(svg, image) {
      const tmpIds = svg.node.innerHTML.match(new RegExp(`id="${image.id}[-]*[0-9]*"`, 'g'))
      tmpIds.forEach(tmpId => {
        const tmp = tmpId.match(new RegExp(`${image.id}[-]*[0-9]*`))
        const element = svg.findOne(`#${tmp[0]}`)
        if (element) {
          const parent = element.parent()
          const attributes = element.attr(['width', 'height'])
          image.value.attr({height: attributes.height, width: attributes.width})
          image.value.transform(element.transform())
          parent.node.innerHTML = image.value.node.outerHTML
        }
      })
    },
    deleteTspan(svg) {
      const texts = svg.find('text')
      if (texts) {
        texts.forEach(text => {
          let x = 0
          let y = 0
          let content = ''
          const elements = text.find('tspan')
          elements.forEach(element => {
            const attributes = element.attr(['x', 'y'])
            x = attributes.x
            y = attributes.y
            content += element.text()
            element.remove()
          })
          text.transform({
            translateX: text.transform().translateX + x,
            translateY: text.transform().translateY + y,
          })
          text.node.innerHTML = content
        })
      }
    },
  },
  computed: {
    svgId() {
      return `form-svg-${this.index}`
    },
    methodDrowPath() {
      return process.env.VUE_APP_METHOD_DROW_PATH
    },
  },
}
</script>

<style lang="scss">
.page {
  position: relative;
  width: 1000px;
  min-height: 500px;
  border: 1px solid black;
  margin: 30px auto;
  padding: 30px;
  font-size: 1.1rem;
  font-weight: normal;
}

@page {
  size: auto;
  margin: 0;
}

@media print {
  body {
    margin: 0;
    padding: 0;
    width: 100% !important;
    height: 100%;
  }

  .page {
    border: none;
    margin: 0;
    page-break-after: always;

    .no-border {
      border: none !important;
    }
  }
}
</style>
